module.exports = __webpack_public_path__ + "img/dierenkliniek_emmeloord.30223c6e.png";